import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getFinancialPlan } from '@/utils/financialPlan';

export const procedureFinancialPlanRoute: RouteConfig = {
  path: 'reports/plan',
  name: 'procedureFinancialPlan',
  component: () =>
    import(/* webpackChunkName: "FinancialPlan" */ '@/views/mainRoute/procedure/details/FinancialPlan.vue'),
  beforeEnter: (to, from, next) => {
    getFinancialPlan(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.REPORT_CANNOT_GET }));
  }
};
